import { FC } from 'react'

import AvatarColor from '@/components/AvatarColor'
import { isNotEmptyArray } from '@/utils'
import './index.less'

// 个人信息
const PersonalInfo: FC<any> = ({
  value: dataSource,
  infoKeys = ['post_name', 'position_name', 'job_type_name'],
  columns = [{ label: '工号', value: 'person_number' }]
}) => {
  const { name = '' } = dataSource || {}

  const hasColumns = isNotEmptyArray(columns)

  return (
    <div className='h-personal-info'>
      <AvatarColor className='h-personal-info-avatar' name={name || ''} count={2} />
      <div className='h-personal-info-title'>
        <div className='name-wrap'>
          <span className='name van-ellipsis-1'>{name}</span>
          <span className='info van-ellipsis-1'>
            {infoKeys
              ?.map((key: string) => dataSource?.[key])
              ?.filter((key: string) => !!key)
              ?.join(' / ')}
          </span>
        </div>
        {hasColumns && (
          <div className='second-line'>
            {columns.map(({ label, value }: any, index: number) => {
              return (
                <span key={index} className={`info info-${index}`}>
                  <span>{label}</span>：{/* 仅有一个不限制内容 */}
                  <span
                    className={`${columns.length > 1 ? 'info-value van-ellipsis-1' : 'single-info-value van-ellipsis-1'}`}
                  >
                    {dataSource?.[value] || ''}
                  </span>
                </span>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}

export default PersonalInfo
